import React, { useCallback } from "react";
import styles from "./FormField.module.scss";
import { MSISDN } from "../../GlobalConstant";

const InputField = ({ field, value = "", error, handleChange, handleFocus, handleBlur }) => {

    const { type, pattern, columns, name, label, required, countryCode, placeholder, maxLength, blockedKeys } = field || {}
    const isPhoneField = type === MSISDN;

    const handleOnChange = useCallback((e) => {
        let inputValue = e.target.value;
        const regex = new RegExp(pattern, "g");
        if (regex) {
            inputValue = inputValue.replace(regex, "");
        }
        handleChange?.(inputValue, field);
    },
        [handleChange, field]
    );

    const handleFieldBlur = useCallback(
        (e) => {
            handleBlur?.(e.target.value, field);
        },
        [handleBlur, field]
    );

    const handleFieldFocus = useCallback(
        (e) => {
            handleFocus?.(e.target.value, field);
        },
        [handleFocus, field]
    );

    const handleKeyDown = useCallback((e) => {
        if (!blockedKeys) return;
        if (blockedKeys.includes(e.key)) {
            e.preventDefault();
        }
    },
        [blockedKeys]
    );

    const wrapperClass = [
        styles["form-group"],
        value ? styles.active : "",
        error ? styles["has-error"] : "",
    ].join(" ");

    return (
        <div
            className={
                styles[`form_field_${columns || "col-6"}`]
            }
        >
            <div className={wrapperClass}>
                <label htmlFor={name}>
                    {label}
                    {required && <span>*</span>}
                </label>

                <div className={styles["input-bx"]}>
                    {countryCode && (
                        <span className={styles.countryCode}>
                            +{countryCode}
                        </span>
                    )}

                    <input
                        id={name}
                        type="text"
                        name={name}
                        placeholder={placeholder}
                        autoComplete={isPhoneField ? "tel" : "off"}
                        inputMode={isPhoneField ? "numeric" : undefined}
                        value={value}
                        onChange={handleOnChange}
                        onFocus={handleFieldFocus}
                        onBlur={handleFieldBlur}
                        onKeyDown={handleKeyDown}
                        className={styles["form-control"]}
                        maxLength={maxLength}
                        aria-invalid={!!error}
                    />
                </div>

                {error && error !== true && (
                    <div className={styles.error}>{error}</div>
                )}
            </div>
        </div>
    );
};

export default React.memo(InputField);